import React from 'react';
import classnames from 'classnames';
import { Radio as AntdRadio, RadioProps, RadioGroupProps } from 'antd';

import './style.scss';

const PREFIX = 'music';

function Radio(props: RadioProps) {
  const { className, ...rstProps } = props;

  return <AntdRadio className={classnames(`${PREFIX}-radio`, className)} {...rstProps} />;
}

function Group(props: RadioGroupProps) {
  const { className, ...rstProps } = props;

  return <AntdRadio.Group className={classnames(`${PREFIX}-radio-group`, className)} {...rstProps} />;
}

Radio.Group = Group;
Radio.Button = AntdRadio.Button;

export default Radio;
